{
  "Enter Support Case title": "Case title",
  "Support Case Title Header": "Case title",
  "Enter product name your enquiry is about": "Product (like NKS, AKS, EKS...)",
  "Product name header": "Product",
  "Enter the version of the product you use": "Product version",
  "Product version header": "Version",
  "Select the severity of the case": "Case severity",
  "Case severity": "Severity",
  "Critical (severity)": "Critical",
  "Major (severity)": "Major",
  "Normal (severity)": "Normal",
  "Minor (severity)": "Minor",
  "Case status": "Status",
  "Create case": "Save case",
  "Update case meta": "Update",
  "Create new case ...": "Start new case",
  "Ask (question)": "Ask",
  "Support case metadata": "Case info",
  "Error receiving response for user message": "Error receiving response for user message",
  "There are no preceding messages to display": "Create or select a Support Case",
  "Reference document": "Reference document",
  "Conversation": "Conversation",
  "Case history": "Case history",
  "No conversation to display": "No conversation to display",
  "You need to log in to see past cases": "You need to log in to see past cases",
  "Log in to access support case": "Please log in",
  "Technical support assistant": "Technical Support Assistant",
  "Cookie consent": "We use necessary cookies to make our site work. We’d like to set additional cookies to understand site usage, make site improvements and to remember your settings. We also use cookies set by other sites to help deliver content from their services. View our cookie notice",
  "Accept cookies": "Accept cookies",
  "Decline cookies": "Decline",
  "Cancel creation": "Cancel",
  "Create new case (modal)": "New case",
  "Case created by": "Opened by",
  "Someone (from the organization)": "Someone",
  "escalation tag": "escalation",
  "Enter the jira project key": "Jira project key for exporting",
  "Actions (for Support Case)": "Actions",
  "Close case": "Close case",
  "Close and learn case": "Close and learn case",
  "Delete case": "Delete case",
  "Error receiving response for closure": "Error receiving response for closure",
  "Case is closed at": "Case is closed at {{ closureTime }}",
  "Jira key missing": "Jira key missing",
  "Welcome message": "Welcome to the Technical Support Assistant. I am going to guide you through the best AI assisted support experience. Please start typing your question or problem I can help you with.",
  "Time to respond": "Time to respond",
  "Escalate": "Forward case",
  "Open in": "Open in ",
  "Creation time": "Creation time",
  "Case creation time header": "Created",
  "Case deleted permanently": "Case deleted permanently",
  "organization name: enoventum": "eNoventum Labs Kft.",
  "organization name: testgroup": "Test Group",
  "organization name: rewe": "REWE GROUP",
  "draft kb status": "Draft",
  "proposed kb status": "Proposed for inclusion in knowledge base",
  "published kb status": "Published to knowledge base",
  "none kb status": "None",
  "All cases": "All cases",
  "Open cases": "Open cases",
  "My cases": "My cases",
  "Learnt cases": "Learnt cases",
  "Proposed for learning": "Proposed for learning",
  "Propose to use learning in future cases": "Propose to use learning in future cases",
  "Reject learning": "Reject learning",
  "Reject learning from the case": "Reject learning from the case",
  "Case navigation": "Case navigation",
  "Close the case": "Close the case",
  "Close and propose for learning": "Close and propose for learning",
  "Automatic selection": "Automatic selection",
  "Close the case and learn from it": "Close the case and learn from it",
  "workflow_ask": "Problem solving",
  "workflow_teach": "Teaching",
  "workflow_chit_chat": "Chit-chat",
  "workflow_catalogue": "Catalogue only",
  "Ask a question from Arten": "Ask a question from Arten",
  "Tell Arten a new directive or information to remember": "Tell Arten a new directive or information to remember",
  "Settings": "Settings",
  "Slack Integration": "Slack Integration",
  "Teams Integration": "Teams Integration",
  "Click to assign organization": "Click to assign organization",
  "Not a system administrator": "Not a system administrator",
  "Delete Teams Integration Action": "Delete",
  "Click to delete integration": "Click to delete integration",
  "Actions": "Actions",
  "Forward case action": "Involve human support into the support case",
  "Close case action": "Mark solved",
  "Close and learn case action": "Mark solved and draw conclusions for future use",
  "Close and propose for learning case action": "Mark solved and propose to admins to draw conclusions for future use",
  "Delete case action": "Delete the case permanently",
  "Publish learning action": "Draw conclusions for future use",
  "Reject learning action": "Delete conclusions drawn",
  "How can I help user?": "How can I help, {{user}}?",
  "Hi <user>": "Hi {{user}}",
  "How can I help?": "How can I help?",
  "More options": "More options",
  "Cases": "Recent cases",
  "Search cases": "Search cases",
  "Privacy Policy": "Privacy Policy",
  "Terms of Service": "Terms of Service",
  "Delete": "Delete",
  "Cancel": "Cancel",
  "No recent cases": "No recent cases",
  "Are you sure you want to delete this case? This action cannot be undone.": "Are you sure you want to delete this case? This action cannot be undone.",
  "Ok": "Ok",
  "Confluence Admin": "Confluence Admin",
  "Documentation": "Documentation",
  "Help": "Help",
  "About": "About",
  "Cancellation warning": "You are about to cancel your subscription. This action will take effect at the end of the current billing period. No further overages will be allowed in the cancellation period. You will not be able to use the service after the current billing period. Are you sure you want to proceed?",
  "Subscription creation confirmation": "You are about to subscribe to plan \"{{planName}}\". You will be charged {{price}} {{currency}} at the beginning of each billing period. This includes {{amountIncluded}} support cases. If you exceed this amount, we will charge {{overagePrice}} {{currency}} per additional case. Are you sure you want to proceed?",
  "Subscription update confirmation": "You are about to update your subscription to plan \"{{planName}}\". This action will take effect immediately. Your current subscription will be canceled and your potentially remaining support cases will be lost. You will be charged {{price}} {{currency}} at the beginning of each billing period. This includes {{amountIncluded}} support cases. If you exceed this amount, we will charge {{overagePrice}} {{currency}} per additional case. Your new billing period will start immediately. Are you sure you want to proceed?"
}